import axiosInstance from "@/api/axios-instance";

export async function updateUsageIdentifier(source_id: string, usage_identifier?: string | null) {
  const response = await axiosInstance.post(`/sessions/updateUsageIdentifier`, {
    source_id,
    usage_identifier,
  });

  if (!response.status.toString().startsWith("2")) {
    throw new Error("Failed to cancel session");
  }

  return response.data;
}